var map = {
	"./template.betgalaxy": 2060,
	"./template.betgalaxy.tsx": 2060,
	"./template.betprofessor": 1136,
	"./template.betprofessor.tsx": 1136,
	"./template.betroyale": 1137,
	"./template.betroyale.tsx": 1137,
	"./template.default": 660,
	"./template.default.tsx": 660,
	"./template.fiestabet": 1138,
	"./template.fiestabet.tsx": 1138,
	"./template.puntcity": 1139,
	"./template.puntcity.tsx": 1139,
	"./template.puntgenie": 1140,
	"./template.puntgenie.tsx": 1140,
	"./template.questbet": 1141,
	"./template.questbet.tsx": 1141,
	"./template.ts": 970,
	"./template.volcanobet": 1142,
	"./template.volcanobet.tsx": 1142,
	"./template.wellbet": 1143,
	"./template.wellbet.tsx": 1143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2430;